export default "__VITE_ASSET__elyJyjhO__ 1000w";